import React from "react";
import { withStyles } from "material-ui/styles";

const styles = theme => ({
  ul: {
    listStyle: "none",
    padding: "5px 10px",
    margin: 0,
    border: "1px solid",
    borderColor: theme.palette.error[700],
    color: theme.palette.error[700],
    background: theme.palette.error[50],
    borderRadius: 3
  }
});

const ErrorMessage = props => {
  const canShow = props.messages && props.messages.length > 0;

  return canShow ? (
    <div className={props.className}>
      <ul className={props.classes.ul}>
        {props.messages.map(message => <li key={message}>{message}</li>)}
      </ul>
    </div>
  ) : null;
};

export default withStyles(styles)(ErrorMessage);



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.jsx